import { updateFolderIdsIfNeeded } from '../actions/internalActions';
import {
    initializeDayView,
    resetDayGridScenario,
    selectDayGridDate,
} from '../actions/publicActions';
import DayGridScenario from '../schema/DayGridScenario';
import getScenarioStore from '../selectors/getScenarioStore';
import { KnownItemTypes } from 'owa-calendar-surface-dategrid';
import { orchestrator } from 'satcheljs';
import { createDayGridScenario } from '../actions/dayGridActions';
import {
    initializeSchedulingGrid,
    navigateToDate,
    updateSelectionItem,
    convertToCalendarEvent,
    resetSchedulingGrid,
    updateFolderIds,
    refreshSchedulingGrid,
} from 'owa-calendar-scheduling-grid';
import {
    calendarEventsAdded,
    calendarEventsRemoved,
    calendarEventUpdated,
    subscribeNotifications,
} from 'owa-calendar-events-store';
import {
    calendarFolderIdNeedsUpdate,
    getAndUpdateActualFolderId,
    getFolderIdByCalendarID,
    initializeCalendarsCache,
    isLocalCalendarEntry,
} from 'owa-calendar-cache';

orchestrator(initializeDayView, ({ scenario, initialDate, focusTime }) => {
    // The grid need the cache to be initialized before itself.
    // Initialize the cache here and handle the grid initialization in
    // the orchestrator below.
    initializeCalendarsCache('OwaDayGrid');

    let store = getScenarioStore(scenario);

    if (store && store.schedulingGridViewState) {
        navigateToDate(store, initialDate);
        if (focusTime) {
            updateSelectionItem(
                store,
                convertToCalendarEvent(
                    { Start: focusTime, End: focusTime },
                    KnownItemTypes.suggestedItems
                )
            );
        }
    } else {
        createDayGridScenario(scenario);
        store = getScenarioStore(scenario);

        initializeSchedulingGrid
            .importAndExecute(
                store,
                [], // Folder ids, these will be updated after first render when the cache is ready.
                initialDate,
                null, //selectionItem
                null // filter items function
            )
            .then(() => {
                if (focusTime) {
                    updateSelectionItem(
                        store,
                        convertToCalendarEvent(
                            { Start: focusTime, End: focusTime },
                            KnownItemTypes.suggestedItems
                        )
                    );
                }
            });
    }
});

orchestrator(selectDayGridDate, ({ scenario, newDate }) => {
    const store = getScenarioStore(scenario);
    navigateToDate(store, newDate);
});

orchestrator(resetDayGridScenario, ({ scenario }) => {
    const store = getScenarioStore(scenario);
    const lockId = store.schedulingGridViewState.eventsCacheLockId;
    resetSchedulingGrid(store, lockId);
});

orchestrator(updateFolderIdsIfNeeded, async ({ scenario, calendarIds }) => {
    const store = getScenarioStore(scenario);
    await initializeSchedulingGrid.import();
    await Promise.all(
        calendarIds.filter(calendarFolderIdNeedsUpdate).map(getAndUpdateActualFolderId)
    );

    const selectedFolders = getSelectedFolders(calendarIds);
    selectedFolders.forEach(subscribeToNotifications);

    updateFolderIds(store, selectedFolders);
});

// TODO VSO 46548 investigate exposing controlled and uncontrolled versions of scheduling grid
orchestrator(calendarEventsAdded, refreshUncontrolledGrids);
orchestrator(calendarEventsRemoved, refreshUncontrolledGrids);
orchestrator(calendarEventUpdated, refreshUncontrolledGrids);

function getSelectedFolders(calendarIds: string[]): string[] {
    return calendarIds.filter(id => !calendarFolderIdNeedsUpdate(id)).map(getFolderIdByCalendarID);
}

function subscribeToNotifications(folderId: string) {
    if (isLocalCalendarEntry(folderId)) {
        // TODO-VSO #29078: Subscribe to group calendar notifications if its a group calendar
        subscribeNotifications(folderId);
    }
}

function refreshUncontrolledGrids() {
    [DayGridScenario.ConflictsView, DayGridScenario.DayView].forEach(scenario => {
        const store = getScenarioStore(scenario);
        if (store) {
            refreshSchedulingGrid(store);
        }
    });
}
